'use strict';
angular.module('weixinModule', [
    'weixinRouterModule',
    'weixinLeftModule',
    'weixinToBeCompiledModule',
    'weixinPendingModule',
    'weixinSignedModule',
    'weixinGroupModule',
    'weixinPreviewHistoryModule',
    'weixinEditPageModule',
    'weixinServiceModule',
    'editingCenterWeixinPreviewRouterModule',
    'wxRecycleModule'
])
    .controller('weixinCtrl', [function () {

    }])
    .value('weixinConst', {
        listenStroageKey: 'Weixin', // 监听缓存的名称
        trial: {
            // 送审参数
            serviceid: 'mlf_wechatoper',
            methodname: 'trialMetaDatas',
        },
        rejection: {
            serviceid: 'mlf_wechatoper',
            methodname: 'rejectionMetaDatas',
        },
        delete: {
            serviceid: 'mlf_wechatoper',
            methodname: 'trashMetaDatas',
        },
        daibianSign: {
            serviceid: 'mlf_wechatoper',
            methodname: 'webDaiBianPublish',
        },
        daishenSign: {
            serviceid: 'mlf_wechatoper',
            methodname: 'webDaiShenPublish',
        },
        yiqianfaSign: {
            serviceid: 'mlf_wechatoper',
            methodname: 'webYiQianPublish',
        },
        draftListDB: {
            // 待编发稿单参数
            serviceid: 'mlf_appfgd',
            methodname: 'weChatDaiBianbatchUpdateFgdUsers',
        },
        draftListDS: {
            // 待审发稿单参数
            serviceid: 'mlf_appfgd',
            methodname: 'weChatDaiShenbatchUpdateFgdUsers',
        },
        draftListQuery: {
            // 发稿单查询参数
            serviceid: 'mlf_appfgd',
            methodname: 'queryFgdByMetaDataId',
        },
        withdrawrejection: {
            serviceid: 'mlf_wechatoper',
            methodname: 'withdraw',
        },
        collectDB: {
            serviceid: 'mlf_wechatoper',
            methodname: 'collectionDAIBIANDocs',
        },
        collectDS: {
            serviceid: 'mlf_wechatoper',
            methodname: 'collectionDAISHENDocs',
        }
        
    });
